import type { ActivitySelectorV1Attributes } from '@/features/activity-selector-v1/activity-selector-v1-type';

import React from 'react';

import dynamic from 'next/dynamic';

import { PenIcon } from '@/assets/icons/pen';
import color from '@/core/features/styles/color';

import styles from './activity-selector-v1.module.scss';

const ActivitySelectorOverlay = dynamic(
    () => import(/* webpackChunkName: "ActivitySelectorOverlay" */ './activity-selector-overlay'),
);

export default function ActivitySelectorV1({ activities, ctaText, title }: ActivitySelectorV1Attributes) {
    const [isOverlayOpen, setOverlayOpen] = React.useState(false);

    return (
        <div>
            <button
                className={`flex-center gap-horizontal ${styles.activityButton}`}
                data-qa-id={'qa-activity-selector'}
                onClick={() => setOverlayOpen(true)}
            >
                {ctaText}
                <PenIcon
                    color={color('endeavour')}
                    height={15}
                    width={15}
                />
            </button>

            {isOverlayOpen && (
                <ActivitySelectorOverlay
                    activities={activities}
                    onClose={() => setOverlayOpen(false)}
                    title={title}
                />
            )}
        </div>
    );
}
